import { render, staticRenderFns } from "./UserNotificationsDialog.vue?vue&type=template&id=6fdf02b0"
import script from "./UserNotificationsDialog.vue?vue&type=script&lang=js"
export * from "./UserNotificationsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports